module.exports = __webpack_public_path__ + "img/xrp-issued-asset-movement.25a8a601.png";